<script setup lang="ts">
import { Label, type LabelProps } from 'radix-vue'
import { type HTMLAttributes, computed } from 'vue'
import { cn } from '../../utils'

const props = defineProps<
    LabelProps & {
        class?: HTMLAttributes['class']
        disabled?: boolean
    }
>()

const delegatedProps = computed(() => {
    const { class: _, ...delegated } = props

    return delegated
})
</script>

<template>
    <Label
        v-bind="delegatedProps"
        :class="
            cn(
                'flex items-start text-sm font-medium text-neutral-900',
                {
                    'text-neutral-500': disabled,
                },
                props.class
            )
        "
    >
        <slot />
    </Label>
</template>
